const verified = defineNuxtRouteMiddleware(() => {
  const sanctumConfig = useSanctumConfig();

  const { isAuthenticated, user } = useSanctumAuth<IUser>();

  if (!isAuthenticated.value) {
    if (sanctumConfig.redirect.onAuthOnly === false) {
      return createError({
        statusCode: 409,
        message: "You must verify your email to access this page",
        fatal: true,
      });
    }

    return navigateTo(sanctumConfig.redirect.onAuthOnly);
  }

  if (user.value?.email_verified) {
    return;
  }

  return navigateTo("/verify");
});

const unverified = defineNuxtRouteMiddleware(() => {
  const sanctumConfig = useSanctumConfig();

  const { isAuthenticated, user } = useSanctumAuth<IUser>();

  if (!isAuthenticated.value) {
    if (sanctumConfig.redirect.onAuthOnly === false) {
      return createError({
        statusCode: 409,
        message: "You must verify your email to access this page",
        fatal: true,
      });
    }

    return navigateTo(sanctumConfig.redirect.onAuthOnly);
  }

  if (!user.value?.email_verified) {
    return;
  }

  return navigateTo("/");
});

export default defineNuxtPlugin(() => {
  // Registered here (instead of as file-based middleware) because Vite's dev
  // server rejects `@fs` requests for filenames containing a colon, e.g.
  // `middleware/sanctum:verified.ts`.
  addRouteMiddleware("sanctum:verified", verified);
  addRouteMiddleware("sanctum:unverified", unverified);
});
